import { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { TbDots } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

// interface ActionsDropdownButtonProps {}

const ActionsDropdownButton: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <Button
            onClick={(event) => {
                event.preventDefault();
            }}
            type='text'
        >
            <TbDots style={{ color: token.colorTextTertiary }} />
        </Button>
    );
};

export default ActionsDropdownButton;
